import { atom } from 'jotai';

export const notificationsUnreadOffsetAtom = atom<{
  serverUnreadCount: number | undefined;
  count: number;
}>({ serverUnreadCount: undefined, count: 0 });
